<script lang="ts">
import entityPanel from '@nuxtDatakodeUtils/components/i3p/panels/entity-panel.vue'
import { I3pEventsEnum } from '@nuxtDatakodeUtils/types/I3pEvents.enum'
import EntityHistorique from '../common/entity/EntityHistorique.vue'
import EntityContact from './entity/EntityContact.vue'
import EntityGlobalInfo from './entity/EntityGlobalInfo.vue'
import { useConfigStore } from '~/store'

type IntentionData = PildomModules.Voirie.Data.IntentionData

// noinspection JSUnusedGlobalSymbols
export default {
    name: 'IntentionEntityPanel',
    components: { EntityContact, EntityGlobalInfo, EntityHistorique },
    extends: entityPanel,
    emits: ['updateMapPosition'],
    computed: {
        intentionData(): IntentionData | null {
            return this.entity?.data
        },
    },
    mounted() {
        this.i3pService.emitter
            .on(I3pEventsEnum.geometryChanged, (event: { geometry: any[] }) => {
                // update geometry data when geometry is change din map panel
                this.updateData({ geometry: event.geometry })
            })
    },
    methods: {
        copyEntityLink() {
            if (process.client) {
                const route = useRoute()
                const configStore = useConfigStore()
                navigator.clipboard.writeText(configStore.currentConfig?.voirie_app_url + route.fullPath)
                this.$showToaster({ text: 'Lien copié', title: '', color: 'info', icon: 'mdi-content-copy' })
            }
        },
        routerPushEntity(k: string | null) {
            if (k) {
                this.$router.push(`${this.baseUrl}/${k}`)
                return
            }
            this.$router.push(`${this.baseUrl}/creation`)
        },
        async saveStatus(status: { status: string }) {
            if (this.entity?.data.k) {
                const res = await this.$api.setRequest({
                    url: `${this.entity.endPoint}/${this.entity?.data.k}/status`,
                    body: status,
                    method: 'PUT',
                    translation: this.entity.translationKey,
                })
                if (!res || res.e instanceof Error)
                    return
                const statusList: string[] = ['_3_done', '_4_cancelled']
                if (statusList.includes(status.status)) {
                    const nextKey = this.i3pService.getNextKey()
                    const previousKey = this.i3pService.getPreviousKey()
                    const router = useRouter()
                    if (nextKey)
                        await this.i3pService.showEntity(nextKey)
                    else if (previousKey)
                        await this.i3pService.showEntity(previousKey)
                    else
                        await router.replace('toutes-les-intentions')
                }
                else {
                    await this.i3pService.reloadCurrenEntity()
                }
                await this.i3pService.refreshData()
            }
        },
    },
}
</script>

<template>
    <div>
        <div v-if="intentionData" class="">
            <!-- border-s-md pl-2 border-primary" -->
            <v-row v-if="!i3pService.editMode" class="mb-2">
                <v-col cols="1" class="pr-0">
                    <v-btn
                        icon="mdi-chevron-left" variant="text" size="small" :disabled="!previousKey"
                        aria-label="Précédent"
                        @click="showEntity(previousKey)"
                    />
                </v-col>
                <v-col>
                    <div class="text-h5 text-center">
                        Visualiser une intention <span
                            class="text-subtitle-2 pl-2 text-medium-emphasis"
                        >{{ intentionData.id }}</span>
                    </div>
                </v-col>
                <v-col cols="1" class="pl-0">
                    <v-btn
                        icon="mdi-chevron-right" variant="text" size="small" :disabled="!nextKey"
                        aria-label="Suivant"
                        @click="showEntity(nextKey)"
                    />
                </v-col>
            </v-row>
            <template v-if="entity">
                <div v-if="!i3pService.editMode" class="mb-2">
                    <v-btn
                        v-if="intentionData && $permissionCheck(`voirie_intention_update`) && intentionData.meta.editable"
                        class="mr-4 mb-2" variant="flat" prepend-icon="mdi-pencil" size="small" color="primary"
                        @click="setEditMode(true)"
                    >
                        Modifier
                    </v-btn>

                    <ListDeleteConfirmation
                        v-if="intentionData && $permissionCheck(`voirie_intention_destroy`) && intentionData.meta.deletable"
                        :item="intentionData"
                        :translation-name="entity.translationKey"
                        button="<v-btn class='mr-4 mb-2' variant='outlined' prepend-icon='mdi-delete' size='small' color='primary'>Supprimer</v-btn>"
                        @delete-data="deleteEntity"
                    />

                    <v-btn
                        class="mr-4 mb-2" variant="text" prepend-icon="mdi-link-variant" size="small" color="primary"
                        @click="copyEntityLink"
                    >
                        Copier le lien
                    </v-btn>
                </div>
                <!-- // SHOW LOADER OON entity.loaded -->
                <EntityGlobalInfo
                    :data="intentionData"
                    :i3p-service
                    :entity
                    @update-data="updateData($event)"
                    @save="saveEntity"
                    @save-status="saveStatus($event)"
                    @update-map-position="$emit('updateMapPosition', $event)"
                />
                <EntityContact :data="intentionData" :entity @update-data="updateData($event)" />

                <EntityHistorique v-if="!i3pService.editMode" :data="intentionData" :entity />
            </template>
        </div>
        <template v-else>
            <div v-if="dataIsEmpty" class="h-screen">
                <div class="text-h5 text-center">
                    Aucun objet sélectionné
                </div>
            </div>
            <div v-else class="h-screen">
                <v-skeleton-loader type="article" />
                <v-skeleton-loader type="paragraph" />
                <v-skeleton-loader type="paragraph" />
            </div>
        </template>
    </div>
</template>
